//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "evaluation",
  methods:{
      tiaoguo(){
        this.axios.post('/xcx/Order/testRecommend',{test_result:2,type:this.$store.state.testLevel+1}).then(res=>{
          this.$router.replace({name:'tutorial'})
        })
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/evaluation/evaluation.vue